export enum FeatureFlags {
  staffFamilyMessagingEnabled = 'staffFamilyMessagingEnabled',
}

export function isFeatureEnabled(
  facility: object | null | undefined,
  flag: FeatureFlags,
): boolean {
  if (!facility) return false;
  return (facility as Record<string, unknown>)[flag] === true;
}
